module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"homepage":"Главная"},"en":{"homepage":"Home"}}')
  delete Component.options._Ctor
}
